var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 20.0352C0 31.0809 8.95431 40.0352 20 40.0352C31.0457 40.0352 40 31.0809 40 20.0352C40 8.98946 31.0457 0.0351562 20 0.0351562C8.95431 0.0351562 0 8.98946 0 20.0352Z",
    fill: "#550080",
    fillOpacity: 0.1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 30.0352H10.25V16.6602H14.5V30.0352ZM12.375 14.7852C11 14.7852 10 13.7852 10 12.4102C10 11.0352 11.125 10.0352 12.375 10.0352C13.75 10.0352 14.75 11.0352 14.75 12.4102C14.75 13.7852 13.75 14.7852 12.375 14.7852ZM30 30.0352H25.75V22.7852C25.75 20.6602 24.875 20.0352 23.625 20.0352C22.375 20.0352 21.125 21.0352 21.125 22.9102V30.0352H16.875V16.6602H20.875V18.5352C21.25 17.6602 22.75 16.2852 24.875 16.2852C27.25 16.2852 29.75 17.6602 29.75 21.7852V30.0352H30Z",
    fill: "#550080"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLn);
export default __webpack_public_path__ + "static/media/Ln.8fdebac6e2a2e68d4cf47c1633748e8a.svg";
export { ForwardRef as ReactComponent };